
import React from 'react';
import { Shell } from "@/components/ui/shell";
import { ScrollArea } from "@/components/ui/scroll-area";
import AuthNavigation from '@/components/navigation/AuthNavigation';

const Policy = () => {
  return (
    <Shell className="max-w-5xl pt-6">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold tracking-tight">Terms and Conditions</h1>
        <AuthNavigation />
      </div>
      
      <div className="space-y-6">
        <div>
          <p className="text-gray-500 dark:text-gray-400 mt-2">Last updated: April 25, 2025</p>
        </div>
        
        <ScrollArea className="h-[600px] rounded-md border p-6">
          <div className="space-y-6">
            <section>
              <h2 className="text-xl font-semibold mb-3">1. Introduction</h2>
              <p className="text-gray-600">These terms and conditions govern your use of Bluetooth$ and the services we provide. By using our service, you accept these terms and conditions in full.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">2. Payment Services</h2>
              <p className="text-gray-600">Our payment services use Bluetooth technology to facilitate secure transfers between users. All transactions are processed through our secure payment system in partnership with Stripe.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">3. Security</h2>
              <p className="text-gray-600">We employ advanced security measures, including AI verification and end-to-end encryption, to protect your transactions and personal information.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">4. User Responsibilities</h2>
              <p className="text-gray-600">Users are responsible for maintaining the security of their account credentials and ensuring their device's Bluetooth functionality is secure.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">5. Service Availability</h2>
              <p className="text-gray-600">While we strive to provide uninterrupted service, we cannot guarantee that our services will be available 100% of the time.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">6. Fees</h2>
              <p className="text-gray-600">Our service charges a 5% fee per transaction. Additional fees may apply based on the payment method and transaction type.</p>
            </section>

            <section>
              <h2 className="text-xl font-semibold mb-3">7. Changes to Terms</h2>
              <p className="text-gray-600">We reserve the right to modify these terms at any time. Users will be notified of any changes.</p>
            </section>
          </div>
        </ScrollArea>
      </div>
    </Shell>
  );
};

export default Policy;
